import { render } from "./IosDeutsch.vue?vue&type=template&id=bd89704a&scoped=true"
import script from "./IosDeutsch.vue?vue&type=script&lang=js"
export * from "./IosDeutsch.vue?vue&type=script&lang=js"

import "./IosDeutsch.vue?vue&type=style&index=0&id=bd89704a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd89704a"]])

export default __exports__